import { render, staticRenderFns } from "./step1-addressee.vue?vue&type=template&id=336f8dee"
import script from "./step1-addressee.vue?vue&type=script&lang=js"
export * from "./step1-addressee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports